import React, { useState } from "react";
import { collection, doc, setDoc } from "firebase/firestore";
// import { useHistory } from 'react-router';
import { auth } from "./firebaseConfig";
import { signOut } from "firebase/auth";
import { Link } from "react-router-dom";

import { database, StorageFolder } from "./firebaseConfig";
import {
  Box,
  Button,
  Center,
  ChakraProvider,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Stack,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbSeparator,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Image,
  useMediaQuery,
  TableContainer,
} from "@chakra-ui/react";
// import { useAuthContext } from './authContext';
import FormMenu from "./FormMenu";
import NavBar from "./NavBar";
import Logo from "./Logo";
import UploadDataButton from "./UploadDataButton";
import UploadDataTable from "./UploadDataTable";
import { useLanguage } from "./languageContext";

type DataRow = string[]; // Change this type definition based on your data
const headerRow = [
  // TODO: Change header rows based on your data
  "Station",
  "Year",
  "Month",
  "Date",
  "Time",
  "X",
  "Y",
  "Category",
  "Common Name",
  "Scientific Name",
  "IUCN",
  "National Category",
  "Number of Individuals",
];
const FaunaUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [dataRows, setDataRows] = useState<DataRow[]>([]); // Set the type for dataRows
  const [isSmallScreen] = useMediaQuery("(max-width: 1100px)");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    const reader = new FileReader();
    reader.onload = () => {
      const fileContent = reader.result;
      const parsedData = parseCSVData(fileContent);

      if (parsedData.length > 0 && parsedData[0].length !== headerRow.length) {
        alert(
          language === "english"
            ? "The data is not in the correct format. Please use the correct format."
            : "Los datos no están en el formato correcto. Por favor, use el formato correcto."
        );
        setSelectedFile(null);
      }
    };

    reader.readAsText(file);
  };

  const parseCSVData = (data) => {
    const rows = data.trim().split("\n");
    console.log("Rows:", rows);
    const parsedData = rows.map((row) => row.split(","));
    return parsedData.slice(1);
  };

  const handleConvertToCSV = () => {
    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });

    const currentDate = new Date()
      .toISOString()
      .replace(/[-:.]/g, "")
      .slice(0, 15);

    const filename = `Registro_${currentDate}.csv`;

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(url);
    setShowSuccessModal1(true);
  };

  const SuccessModal = ({ isOpen, onClose }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {language === "english" ? "Successful" : "Exitoso"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {language === "english"
              ? "Data uploaded successfully!"
              : "¡Datos subidos exitosamente!"}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="teal" onClick={onClose}>
              {language === "english" ? "Exit" : "Salir"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const SuccessModal1 = ({ isOpen, onClose }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {language === "english" ? "Successful" : "Exitoso"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {language === "english"
              ? "Excel file downloaded successfully!"
              : "¡Archivo de Excel descargado con éxito!"}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="teal" onClick={onClose}>
              {language === "english" ? "Exit" : "Salir"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  const [showSuccessModal1, setShowSuccessModal1] = useState(false);

  const handleSignOut = async () => {
    try {
      // Sign out from Firebase authentication
      await signOut(auth);
      // Navigate to the login page
      window.location.href = "/";
    } catch (error) {
      console.log(
        language === "english"
          ? "Error signing out:"
          : "Error al cerrar sesión:",
        error
      );
    }
  };

  const handleAddUser = async () => {
    try {
      window.location.href = "/AddUser";
    } catch (error) {
      console.log(
        language === "english"
          ? "Error Adding User"
          : "Error al agregar usuario",
        error
      );
    }
  };
  const uploadFaunaData = async (rowData) => {
    const [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13] = rowData;
    const data = {
      Station: c1,
      Year: c2,
      Month: c3,
      Date: c4,
      Time: c5,
      X: c6,
      Y: c7,
      Category: c8,
      CommonName: c9,
      ScientificName: c10,
      IUCN: c11,
      NationalCategory: c12,
      NumberofIndividuals: c13,
      IngestionDate: date,
    };

    try {
      const docRef = doc(collection(database, "Fauna"));
      await setDoc(docRef, data);
      console.log(
        language === "english"
          ? "Successfully Added document" + docRef.id
          : "Documento agregado con éxito" + docRef.id
      );
    } catch (e) {
      console.log(
        language === "english"
          ? "error adding document"
          : "error al agregar documento"
      );
    }
  };

  const UploadDocument = async (event) => {
    event.preventDefault();

    if (selectedFile) {
      console.log(
        language === "english" ? "Selected File:" : "Archivo Seleccionado:",
        selectedFile
      );
      const reader = new FileReader();
      reader.onload = () => {
        const fileContent = reader.result;
        const parsedData = parseCSVData(fileContent);
        setDataRows(parsedData);
      };

      reader.readAsText(selectedFile);

      const currentDate = new Date()
        .toISOString()
        .replace(/[-:.]/g, "")
        .slice(0, 15);

      const uploadfile = StorageFolder.ref(
        `/files/Fauna_Data/${currentDate}.csv`
      ).put(selectedFile);

      await uploadfile;
    }

    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    URL.revokeObjectURL(url);

    // TODO: Clarify if this is the correct way to upload data
    dataRows.forEach((row) => {
      uploadFaunaData(row);
    });

    setShowSuccessModal(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (selectedFile) {
      console.log(
        language === "english" ? "Selected File:" : "Archivo Seleccionado:",
        selectedFile
      );
      const reader = new FileReader();
      reader.onload = () => {
        const fileContent = reader.result;
        const parsedData = parseCSVData(fileContent);
        setDataRows(parsedData);
      };

      reader.readAsText(selectedFile);
    }
  };
  const { language, toggleLanguage } = useLanguage();

  return (
    <ChakraProvider>
      <Box
        backgroundImage={"url(bird.jpeg)"}
        backgroundSize="cover"
        // backdropFilter="auto"
        // backdropBlur={"5px"}
      >
      <NavBar />
      <VStack spacing={4} align="stretch">
        <Center>
          <Stack align="center">
            <Box
              p={4}
              pt={"10%"}
              width={{ base: "100%", md: "100%" }}
              maxW="1100px"
              minH="100vh"
            >
              <Box p={8} bg="white" rounded="md" shadow="md" width="100%">
                <SuccessModal1
                  isOpen={showSuccessModal1}
                  onClose={() => setShowSuccessModal1(false)}
                />
                <SuccessModal
                  isOpen={showSuccessModal}
                  onClose={() => setShowSuccessModal(false)}
                />

                <FormMenu isSmallScreen={isSmallScreen} />
                <Logo isSmallScreen={isSmallScreen} />

                <Box textAlign="center">
                  <Heading fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}>
                    {language === "english"
                      ? "Upload Fauna CSV File"
                      : "Subir archivo CSV de Fauna"}
                  </Heading>
                </Box>

                <form onSubmit={handleSubmit}>
                  <FormControl marginBottom="20px">
                    <FormLabel>
                      {" "}
                      {language === "english"
                        ? "Select File"
                        : "Seleccionar Archivo"}{" "}
                    </FormLabel>
                    <Input
                      type="file"
                      accept=".csv"
                      onChange={handleFileChange}
                      required
                    />
                  </FormControl>
                  <FormControl id="date" marginBottom="20px">
                    <FormLabel>
                      {" "}
                      {language === "english" ? "Date" : "Fecha"}{" "}
                    </FormLabel>
                    <Input
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      required
                    />
                  </FormControl>

                  <UploadDataButton
                    dataRows={dataRows}
                    UploadDocument={UploadDocument}
                    handleConvertToCSV={handleConvertToCSV}
                  />
                </form>

                {dataRows.length > 0 && (
                  <UploadDataTable headerRow={headerRow} dataRows={dataRows} />
                )}
              </Box>
            </Box>
          </Stack>
        </Center>
      </VStack>
      </Box>
    </ChakraProvider>
  );
};

export default FaunaUpload;
